import React, { Component } from "react";

import {
  Button,
  Wrapper,
  Row,
  Copy,
  Bold,
  Icon
} from "app/NativeComponents/common";

/*
import {
} from 'app/NativeActions';
*/

import ReactResizeDetector from "react-resize-detector";

class ItemHeader extends Component {
  renderSortIcon() {
    if (this.props.section.slug === this.props.sort_by.slug) {
      switch (this.props.sort_by.type) {
        case "asc":
          return (
            <Wrapper
              style={{
                width: 15,
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Icon size={18} icon={"keyboard-arrow-up"} />
            </Wrapper>
          );

        case "desc":
        default:
          return (
            <Wrapper
              style={{
                width: 15,
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Icon size={18} icon={"keyboard-arrow-down"} />
            </Wrapper>
          );
      }
    }

    if (this.props.section.sort_by) {
      return (
        <Wrapper
          style={{ width: 15, alignItems: "center", justifyContent: "center" }}
        >
          <Icon size={12} fa_icon={"sort"} color={"rgba(31,41,51,0.15)"} />
        </Wrapper>
      );
    }

    //hide this to keep same width for header
    return (
      <Wrapper
        style={{ width: 15, alignItems: "center", justifyContent: "center" }}
      ></Wrapper>
    );
  }

  render() {
    return (
      <Wrapper
        className="resize-no-handle"
        style={{
          overflow: "hidden",
          width: this.props.column_width,
          minWidth: this.props.section.main_setion ? 120 : 80,
          maxWidth: 400,
          resize: "horizontal"
        }}
      >
        <ReactResizeDetector
          handleWidth={this.props.resize}
          onResize={width => {
            this.props.adjustColumnWidth({
              width: width,
              slug: this.props.section.slug
            });
          }}
        >
          <Button
            disabled={
              !this.props.section.sort_by ||
              this.props.lists_loading ||
              this.props.lists_refreshing
            }
            onPress={() => {
              if (this.props.section.sort_by) {
                this.props.clearAll();
                this.props.changeSortBy({
                  slug: this.props.section.slug,
                  type:
                    this.props.section.slug !== this.props.sort_by.slug
                      ? this.props.sort_by.type
                      : this.props.sort_by.type === "asc"
                      ? "desc"
                      : "asc"
                });
              }
            }}
            style={{
              padding: 10,
              height: 25,
              borderRightWidth: 1,
              borderRightColor: this.props.colors.border_color,
              borderRightStyle: "solid",
              borderBottomWidth: 1,
              borderBottomColor: this.props.colors.border_color,
              borderBottomStyle: "solid",
              backgroundColor: this.props.colors.background_color,
              alignItems: "flex-start",
              justifyContent: "center"
            }}
          >
            <Row
              style={{
                alignSelf: "stretch"
              }}
            >
              <Wrapper
                style={{
                  flex: 1,
                  alignItems: "flex-start",
                  justifyContent: "center"
                }}
              >
                <Copy
                  style={{
                    whiteSpace: "nowrap"
                  }}
                >
                  <Bold>{this.props.section.title}</Bold>
                </Copy>
              </Wrapper>
              {this.renderSortIcon()}
            </Row>
          </Button>
        </ReactResizeDetector>
      </Wrapper>
    );
  }
}

export default ItemHeader;
